import { cache } from "@/helpers/enhancedArrowGetters";

export default {
	// flags
	hasActiveInitiatorEverJoinedMeeting: cache(
		state => meetingId => {
			return !!state.meetingMap[ meetingId ]?.hasActiveInitiatorEverJoinedMeeting;
		}
	),
	isActiveInitiator: cache( ( state, getters, rootState, rootGetters ) => meetingId => {
		const userProfile = rootGetters[ "userProfile/userProfile" ];
		return !!( state.meetingMap[ meetingId ]?.meetingInitiator === userProfile.personId );
	} ),
	isAttendingMeeting: cache( ( state, getters, rootState, rootGetters ) => meetingId => {
		const userProfile = rootGetters[ "userProfile/userProfile" ];
		return !!state.meetingMap[ meetingId ]?.meetingAttendanceMap[ userProfile.personId ];
	} ),
	isCreatingTopicOutcome: cache(
		state => meetingId => {
			return !!state.meetingMap[ meetingId ]?.isCreatingTopicOutcome;
		}
	),
	isFetchingMeetingNote: cache(
		state => meetingId => {
			return !!state.meetingMap[ meetingId ]?.isFetchingMeetingNote;
		}
	),
	isFinalizingMeeting: cache(
		state => meetingId => {
			return !!state.meetingMap[ meetingId ]?.isFinalizingMeeting;
		}
	),
	isJoiningMeeting: cache(
		state => meetingId => {
			return !!state.meetingMap[ meetingId ]?.isJoiningMeeting;
		}
	),
	isMeetingInProgress: cache(
		state => meetingId => {
			return !!state.meetingMap[ meetingId ]?.isMeetingInProgress;
		}
	),
	isMeetingNoteDirty: cache( state => meetingId => {
		return state.meetingMap[ meetingId ].currentMeetingNote !== state.meetingMap[ meetingId ].pristineMeetingNote;
	} ),
	isMeetingNoteNew: cache(
		state => meetingId => {
			return !!state.meetingMap[ meetingId ]?.isMeetingNoteNew;
		}
	),
	isStartingMeeting: cache(
		state => meetingId => {
			return !!state.meetingMap[ meetingId ]?.isStartingMeeting;
		}
	),
	isStartingTopic: cache(
		state => meetingId => {
			return !!state.meetingMap[ meetingId ]?.isStartingTopic;
		}
	),
	isStoppingMeeting: cache(
		state => meetingId => {
			return !!state.meetingMap[ meetingId ]?.isStoppingMeeting;
		}
	),
	isUpdatingTopicOutcome: cache(
		state => meetingId => {
			return !!state.meetingMap[ meetingId ]?.isUpdatingTopicOutcome;
		}
	),
	isUserAttendingMeeting: cache( state => ( { meetingId, personId, } ) => {
		return !!state.meetingMap[ meetingId ]?.meetingAttendanceMap[ personId ];
	} ),

	// maps
	meetingAttendeeMap: cache( state => meetingId => {
		return state.meetingMap[ meetingId ]?.meetingAttendeeMap;
	} ),
	topicStartMap: cache( state => meetingId => {
		return state.meetingMap[ meetingId ]?.topicStartMap || {};
	} ),
	topicStartTimeMap: cache( state => meetingId => {
		return state.meetingMap[ meetingId ]?.topicStartTimeMap;
	} ),

	// state
	currentMeetingNote: cache( state => meetingId => state.meetingMap[ meetingId ]?.currentMeetingNote ),
	meetingStartTime: cache( state => meetingId => state.meetingMap[ meetingId ]?.startTime ),
	startedTopicId: cache( state => meetingId => state.meetingMap[ meetingId ]?.startedTopicId ),
	selectedTopicId: cache( state => meetingId => state.meetingMap[ meetingId ]?.selectedTopicId ),
	lastSelectedTopicId: cache( state => meetingId => state.meetingMap[ meetingId ]?.lastSelectedTopicId ),
};



// WEBPACK FOOTER //
// ./src/store/modules/meeting/getters.js